// Not a normal notification like the rest of them,
// this class waits for websocket topic notification_auction_global and shows a popup
// anywhere on landproz.com when it happens.


let _ = require('../_.js');
let $ = jQuery;

let on_click_action = null;

_.Notification_Auction_Global = class Notification_Auction_Global {

    static init() {
        _.on_websocket_receive(function (topic, data) {
            // This needs to be async.
            (async function () {
                if (topic == "notification_auction_global") {
                    console.warn(data);
                    if (data.show_only_for_auction && (!_.ac_state.auction || _.ac_state.auction.id != data.auction_id)) {
                        return;
                    }
                    if (data.show_only_for_auction && data.show_only_for_non_participants) {
                        // Find out if this person placed any bids in any rounds.
                        let registrant = await _.AuctionUI_Session.get_registrant();
                        if (registrant) {
                            let rounds = await _.ac_state.auction.auction_rounds.fetch_private();
                            for (let round of rounds) {
                                if (round.best_bid_by_user_id) {
                                    // User made a bid.  This popup isn't for them.
                                    return;
                                }
                            }
                        }
                    }

                    // Custom modals
                    if (data.alternative_modal && data.alternative_modal == 'auction_completed_public') {
                        _.show_the_entire_auction_was_completed_modal(data.modal_data);
                    } else {
                        // Default view
                        _.Notification_Auction_Global.show(data);
                    }
                }
            })();
        });

        _.on_ui_update_once("#ac-modal-auction-global-modal-cta-button", function () {
            $(this).click(function () {
                _.Notification_Auction_Global.on_click_button();
            });
        });
    }

    static show(data) {
        $("#ac-modal-auction-global-modal-header").html(data.header);
        if (data.body && data.body != "") {
            $("#ac-modal-auction-global-modal-body").show().html(data.body);
        } else {
            $("#ac-modal-auction-global-modal-body").hide();
        }

        if (data.auction_id && _.ac_state && _.ac_state.auction && _.ac_state.auction.id == data.auction_id) {
            // We are looking at the auction
            $("#ac-modal-auction-global-modal-footer").html(data.footer_is_auction);
            $("#ac-modal-auction-global-modal-cta-button").html(data.call_to_action_label_is_auction);
            on_click_action = null;

        } else {
            // We are NOT looking at the auction
            $("#ac-modal-auction-global-modal-footer").html(data.footer_is_not_auction);
            $("#ac-modal-auction-global-modal-cta-button").html(data.call_to_action_label_is_not_auction);
            on_click_action = data.call_to_action_url;
        }

        if ($("#ac-modal-auction-global-modal-footer").html() == "") {
            $("#ac-modal-auction-global-modal-footer").hide();
        } else {
            $("#ac-modal-auction-global-modal-footer").show();
        }

        $("#ac-modal-auction-global-modal").modal_show();
    }

    static on_click_button() {
        if (on_click_action) {
            document.location.href = on_click_action;
        } else {
            _.Modal.close_unhidable();
        }
    }
}